import styled from 'styled-components'
import { AUTH_FORM_MAX_WIDTH } from '../../utils'

export const Container = styled.div`
  width: 100%;
  max-width: ${AUTH_FORM_MAX_WIDTH};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  /* Override IndexLayout SubTitle styles */
  && {
    margin: 24px auto;

    /* Override Button sibling styles */
    button + button {
      margin-left: 0px;
    }
  }
`

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: ${({ theme }) => theme.fontSizes.D};
  text-align: center;
  margin-top: 8px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.border.A};
  }

  &::before {
    margin-right: 24px;
  }

  &::after {
    margin-left: 24px;
  }
`
